import React, { useState, useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { roleContext, LanguageContext } from "../../../libs/context";
import ProfileMenu from "./ProfileMenu";
import CoursesMenu from "./CoursesMenu";
import ReportsMenu from "./ReportsMenu";
import "./styles.css";

function BottomNavigation(props) {
  const { handleLogout, handleRemoveAccount } = props;
  
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [coursesMenuOpen, setCoursesMenuOpen] = useState(false);
  const [reportsMenuOpen, setReportsMenuOpen] = useState(false);

  const role = useContext(roleContext);
  const language = useContext(LanguageContext);
  const location = useLocation();

  const handleProfileClick = () => {
    setProfileMenuOpen(true);
  };

  const handleCloseProfileMenu = () => {
    setProfileMenuOpen(false);
  };

  const handleCoursesClick = () => {
    setCoursesMenuOpen(true);
  };

  const handleCloseCoursesMenu = () => {
    setCoursesMenuOpen(false);
  };

  const handleReportsClick = () => {
    setReportsMenuOpen(true);
  };

  const handleCloseReportsMenu = () => {
    setReportsMenuOpen(false);
  };
  return (
    <>
      <nav className="bottom-navigation">
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            isActive ? "nav-item active" : "nav-item"
          }
        >
          <img
            src="/images/blue/dashboard-24.png"
            alt="Home"
            className="nav-icon"
          />
          <span className="nav-label">
            {language.home || "Home"}
          </span>
        </NavLink>

        <NavLink
          to="/my-sessions"
          className={({ isActive }) =>
            isActive ? "nav-item active" : "nav-item"
          }
        >
          <img
            src="/images/blue/my-meetings-24.png"
            alt="My Sessions"
            className="nav-icon"
          />
          <span className="nav-label">
            {language.mySessions || "My Sessions"}
          </span>
        </NavLink>

        {role === "Admin" && (
          <NavLink
            to="/admin/user-management"
            className={({ isActive }) =>
              isActive ? "nav-item active" : "nav-item"
            }
          >
            <img
              src="/images/blue/users.png"
              alt="Users"
              className="nav-icon"
            />
            <span className="nav-label">
              {language.instavc_admin_users || "Users"}
            </span>
          </NavLink>
        )}

        <div
          className={
            location.pathname.includes("/admin/class-management") ||
            location.pathname.includes("/admin/classmanagement")
              ? "nav-item active"
              : "nav-item"
          }
          onClick={handleCoursesClick}
        >
          <img
            src="/images/icons/classes.png"
            alt="Courses"
            className="nav-icon"
          />
          <span className="nav-label">{language.courses || "Courses"}</span>
        </div>

        {(role === "Admin" || role === "teacher") && (
          <div
            className={
              location.pathname.includes("/class-reports")
                ? "nav-item active"
                : "nav-item"
            }
            onClick={handleReportsClick}
          >
            <img
              src="/images/blue/reports.png"
              alt="Reports"
              className="nav-icon"
            />
            <span className="nav-label">{language.reports || "Reports"}</span>
          </div>
        )}

        <div
          className={
            location.pathname === "/myprofile" ||
            location.pathname === "/settings"
              ? "nav-item active"
              : "nav-item"
          }
          onClick={handleProfileClick}
        >
          <img
            src="/images/blue/profile.png"
            alt="Profile"
            className="nav-icon"
          />
          <span className="nav-label">{language.myProfile || "Profile"}</span>
        </div>
      </nav>

      {profileMenuOpen && (
        <ProfileMenu
          isOpen={profileMenuOpen}
          onClose={handleCloseProfileMenu}
          handleLogout={handleLogout}
          handleRemoveAccount={handleRemoveAccount}
        />
      )}

      {coursesMenuOpen && (
        <CoursesMenu
          isOpen={coursesMenuOpen}
          onClose={handleCloseCoursesMenu}
        />
      )}

      {reportsMenuOpen && (
        <ReportsMenu
          isOpen={reportsMenuOpen}
          onClose={handleCloseReportsMenu}
        />
      )}
    </>
  );
}

export default BottomNavigation;
